import { render } from "./QueuePage.vue?vue&type=template&id=480c262d&ts=true"
import script from "./QueuePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueuePage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/queue/QueuePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "480c262d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('480c262d', __exports__)) {
    api.reload('480c262d', __exports__)
  }
  
  module.hot.accept("./QueuePage.vue?vue&type=template&id=480c262d&ts=true", () => {
    api.rerender('480c262d', render)
  })

}


export default __exports__